const carouselItems = [
  {
    title: '暑期档 · 必看片单',
    desc: '30部暑期高分新片限时上线，涵盖动作、喜剧、科幻、动画全类型，陪你度过炎炎夏日。每天一部不重样，高分佳作一网打尽。',
    tag: '限时专题',
    img: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20vibe%20with%20warm%20golden%20sunset%20light%2C%20movie%20theater%20marquee%20with%20glowing%20lights%2C%20popcorn%20and%20film%20reel%20elements%2C%20nostalgic%20drive-in%20cinema%20aesthetic%2C%20vibrant%20warm%20colors%2C%20entertainment%20atmosphere%2C%20no%20people%20no%20text&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国产悬疑 · 黄金时代',
    desc: '从《隐秘的角落》到《漫长的季节》，国产悬疑剧迎来品质爆发期。精选50部高能反转剧集，每一集都是颅内高潮。',
    tag: '类型专题',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20cityscape%20at%20twilight%20with%20neon%20signs%20reflecting%20on%20wet%20streets%2C%20film%20noir%20atmosphere%2C%20deep%20blue%20and%20amber%20contrast%2C%20rainy%20urban%20scene%2C%20moody%20cinematic%20lighting%2C%20mystery%20thriller%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '动漫专区 · 次元盛宴',
    desc: '1000+部热门番剧一站收录，从经典老番到当季新番，从热血少年到治愈日常。日语原声+中文字幕，二次元爱好者的精神家园。',
    tag: '新专区',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime-style%20cityscape%20at%20sunset%20with%20floating%20cherry%20blossom%20petals%2C%20colorful%20neon%20signs%2C%20dramatic%20sky%20with%20pink%20and%20orange%20gradient%2C%20Japanese%20urban%20aesthetic%2C%20clean%20illustration%20style%2C%20no%20characters%20visible&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '4K修复 · 经典重映',
    desc: '《霸王别姬》《花样年华》《大话西游》等华语经典全新4K数字修复版独家上线。以超清画质重温光影传奇，每一帧都是艺术品。',
    tag: '经典重温',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20casting%20warm%20golden%20light%20in%20a%20dark%20room%2C%20old%20film%20strips%20and%20reels%20scattered%2C%20nostalgic%20cinema%20atmosphere%2C%20dust%20particles%20floating%20in%20light%20beam%2C%20warm%20sepia%20tones%2C%20classic%20movie%20aesthetic&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '韩剧热播 · 限时上线',
    desc: '最新韩剧同步更新，从浪漫爱情到悬疑惊悚，从古装史剧到职场喜剧。韩语原声+精准中字，追剧党不可错过的宝藏合集。',
    tag: '海外热剧',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Seoul%20cityscape%20at%20sunset%20with%20warm%20golden%20light%2C%20cherry%20blossom%20trees%20lining%20the%20street%2C%20modern%20Korean%20architecture%2C%20soft%20dreamy%20atmosphere%2C%20romantic%20cinematic%20lighting%2C%20K-drama%20aesthetic%2C%20no%20people%20visible&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">精彩专题</h2>
          <p className="text-sm text-foreground-500">精心策划 · 一站直达你感兴趣的内容</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={`爱豆影视专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="text-lg md:text-xl font-semibold text-background-50 mb-2">{item.title}</h3>
                  <p className="text-sm text-background-50/80 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}